<div (mouseenter)="toggleUnfold()" (mouseleave)="toggleFold()" class="navbar">
  <div class="navbar-header accent-darker-bg" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo pointer" (click)="gotoHome()">
      <img *ngIf="!showIcon()" class="logo-text" ngSrc="assets/images/logos/logo-text_white.svg" alt="" fill>
      <img *ngIf="showIcon()" class="logo-ico" ngSrc="assets/images/logos/logo_no_text_white.svg" alt="" width="24"
        height="21">
    </div>

  </div>

  <div class="navbar-content" fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: false}"
    [ngClass]="fuseConfig.layout.navbar.primaryBackground">
    <fuse-navigation layout="vertical"></fuse-navigation>
  </div>
</div>
